import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PartnersServiceService } from '../../../../shared/API-Service/services/partners.service';
import Swal from 'sweetalert2';
import {BaseComponent } from '../../../../../app/shared/components/base/base.component'
@Component({
  selector: 'app-list-our-partners',
  templateUrl: './list-our-partners.component.html',
  styleUrls: ['./list-our-partners.component.css']
})
export class ListOurPartnersComponent extends BaseComponent implements OnInit {
  Partners: any;

  constructor(private PartnersService:PartnersServiceService,private _Router:Router) { super()}

  ngOnInit(): void {
    this.getPartners();
    
  }
  pageChanged(event: any){
    this.pageNumber = event.page;// -1 * pageSize;
    this.pager.skipCount = (this.pageNumber - 1) * this.pager.maxResultCount;
    this.PartnersService.GetPartnersPaged(this.pager).subscribe((res) => {
      this.Partners = res.data.items
      this.totalCount=res.data.totalCount;
    console.log(this.Partners);
    
    },(err)=>{
      console.log('their is a problem');
    },() =>{
      console.log('Completed');
    });

  }
  getPartners(){
    const data={
      "maxResultCount": this.pager.maxResultCount,
      "skipCount": this.pager.skipCount,
    }
    this.PartnersService.GetPartnersPaged(data).subscribe((res) => {
      this.Partners = res.data.items
      this.totalCount=res.data.totalCount;
    console.log(this.Partners);
    
    },(err)=>{
      console.log('their is a problem');
    },() =>{
      console.log('Completed');
    });
  }
  update(id){
    console.log(id);
    //this.PartnersService.Data.next(data);
    // this._Router.navigate(['/content/admin/insert-partner']);
    this._Router.navigate(['/content/admin/update-partner',id]);
    }

    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this.PartnersService.DeletePartner(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getPartners();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
            console.log("completed");
          })
        }
      }) 
    }

}
